import { render, staticRenderFns } from "./actShareTemp.vue?vue&type=template&id=f7839ad8&scoped=true&"
import script from "./actShareTemp.vue?vue&type=script&lang=js&"
export * from "./actShareTemp.vue?vue&type=script&lang=js&"
import style0 from "./actShareTemp.vue?vue&type=style&index=0&id=f7839ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7839ad8",
  null
  
)

component.options.__file = "actShareTemp.vue"
export default component.exports